// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._19it7r9e{border:var(--ds-border-width,1px) solid var(--ds-border,#091e4224)}\n._2rko12b0{border-radius:var(--ds-radius-small,4px)}._18u0r5cr{margin-left:var(--ds-space-negative-050,-4px)}\n._1bah1h6o{justify-content:center}\n._1bsbgktf{width:20px}\n._1e0c1txw{display:flex}\n._2hwxr5cr{margin-right:var(--ds-space-negative-050,-4px)}\n._4cvr1h6o{align-items:center}\n._4t3igktf{height:20px}", ""]);
// Exports
module.exports = exports;
